define('drops/slider/slider',[
    'jquery',
    'nouislider',
    'lq/drop',
    'lq/style'
], function ($, noUiSlider, Drop, Style) {
    'use strict';

    var defaults = {
        data: {
            initialValue: 5,
            minValue: 0,
            maxValue: 10,
            stepSize: 1,
            orientation: 'horizontal',
            handleSize: {
                width: 15,
                height: 15
            },
            barSize: 8
        }
    };

    function Slider(options) {
        Drop.call(this, $('<div class="slider-drop"/>'), defaults, options);

        this.$slider = $('<div/>')
            .appendTo(this.$element);

        this.createSlider();
        this.renderStyles();
    }

    Drop.extend(Slider, Drop);

    Slider.typeName = 'Slider';
    
    Slider.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    Slider.prototype.createSlider = function () {
        // note: the library throws an error when passing in boxed numbers...
        noUiSlider.create(this.$slider[0], {
            start: Number(this.data.initialValue).valueOf(),
            step: Number(this.data.stepSize).valueOf(),
            orientation: this.data.orientation,
            range: {
                'min': Number(this.data.minValue).valueOf(),
                'max': Number(this.data.maxValue).valueOf()
            }
        });

        var self = this;
        var changedEvent = this.getEventDataFor('changed');
        if (changedEvent.enabled) {
            this.$slider[0].noUiSlider.on('change', function () {
                var value = self.$slider[0].noUiSlider.get();
                self.triggerEvent(changedEvent.raisedEventName, value);
            });
        }

        var slideEvent = this.getEventDataFor('slide');
        if (slideEvent.enabled) {
            this.$slider[0].noUiSlider.on('slide', function () {
                var value = self.$slider[0].noUiSlider.get();
                self.triggerEvent(slideEvent.raisedEventName, value);
            });
        }
    };

    Slider.prototype.renderStyles = function () {
        Style.renderStyles(this);

        var $handle = this.$slider.find('.noUi-handle');

        Style.renderStyles(this, null, $handle, this.data.styles, 'sliderHandle');
        Style.renderStyles(this, null, this.$slider.find('.noUi-base'), this.data.styles, 'sliderBar');

        if (this.data.orientation === 'horizontal') {
            this.$slider.css({
                width: '100%',
                height: this.data.barSize
            });

            $handle.css({
                width: this.data.handleSize.width,
                height: this.data.handleSize.height,
                top: (this.data.barSize - this.data.handleSize.height) / 2,
                left: -1 * (this.data.handleSize.width / 2)
            });
        } else {
            this.$slider.css({
                width: this.data.barSize,
                height: '100%'
            });

            $handle.css({
                width: this.data.handleSize.width,
                height: this.data.handleSize.height,
                left: (this.data.barSize - this.data.handleSize.width) / 2,
                top: -1 * (this.data.handleSize.height / 2)
            });
        }
    };

    Slider.prototype.getValue = function () {
        return Number(this.$slider[0].noUiSlider.get());
    };

    Slider.prototype.clearValue = function () {
        return this.$slider[0].noUiSlider.set(Number(this.data.initialValue).valueOf());
    };

    Slider.prototype.setValue = function (update) {
        return this.$slider[0].noUiSlider.set(Number(update.value).valueOf());
    };

    return Slider;
});
